import React from "react"
import ThemeProvider from "@material-ui/styles/ThemeProvider"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Articles from "../components/articles"
import theme from "../theme"

const GuidesPage = () => (
  <ThemeProvider theme={theme}>
    <Layout>
      <SEO
        title="Weekly Planning Guides for School & Family"
        description="Find classroom and family schedule examples, calendar tutorials, music, sport and study routines, plus learning principles and study systems. Build a weekly plan."
      />
      <Articles />
    </Layout>
  </ThemeProvider>
)

export default GuidesPage
